var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgTemplateIcon = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.878.923H2.31c-.483 0-.946.162-1.288.45-.341.289-.533.68-.533 1.088v15.385c0 .408.192.8.533 1.088.342.288.805.45 1.288.45h14.567c.482 0 .946-.162 1.287-.45.342-.289.533-.68.533-1.088V2.46c0-.408-.191-.799-.533-1.088a2.003 2.003 0 0 0-1.287-.45Zm0 16.923H2.31V2.46h14.567v15.385Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.132 4h10.925v1.538H4.132V4Zm0 3.076h6.373v1.539H4.132V7.076Zm1.82 9.231h7.284L9.594 14l-3.641 2.307Zm10.015-.769v-4.615l-4.552 2.307 4.553 2.308ZM4.132 10.923v4.615l3.642-2.308-3.642-2.307Zm9.104-.77H5.953l3.641 2.308 3.642-2.308Z",
    fill: "#000"
  })));
};
export { SvgTemplateIcon as ReactComponent };
export default __webpack_public_path__ + "22e84a3ac191c70392ff0b2328d38383.svg";